import React, { useCallback, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';
import { Graphics } from 'pixi.js';

import { gameService } from '../../../../../services/gameService';
import { isMobile } from '../../../../../core/helpers/isMobile';
import { soundService, SoundTypes } from '../../../../../services/soundService';
import { userInfoStore } from '../../../../../store/userInfoStore';

const JackPotSceneItemGraphics = observer(
  ({
    index,
    width,
    height,
    isOpened,
    isAllowDoJackpotAction,
    setIsAllowDoJackpotAction,
    jackPotSceneItemBoxRef,
  }) => {
    const graphicRef = useRef(null);
    const { isReplay } = userInfoStore;

    const handleSelectCard = useCallback(() => {
      if (isAllowDoJackpotAction && !isOpened && !isReplay) {
        setIsAllowDoJackpotAction(false);
        gameService.getJackpotSymbol(index);
      }
    }, [isReplay, isAllowDoJackpotAction, isOpened, index, setIsAllowDoJackpotAction]);

    const handlePointerOver = useCallback(() => {
      if (!isOpened) {
        jackPotSceneItemBoxRef.current.children[0].play('hover');
      }
    }, [jackPotSceneItemBoxRef, isOpened]);

    const handlePointerLeave = useCallback(() => {
      if (!isOpened) {
        jackPotSceneItemBoxRef.current.children[0].stop();
      }
    }, [isOpened, jackPotSceneItemBoxRef]);

    useEffect(() => {
      const graphics = new Graphics();
      graphics.clear();
      graphics.beginFill('black');
      graphics.alpha = 0;
      graphics.drawRect(0, 0, width, height);
      graphics.pivot.set(70, 70);
      graphicRef.current.addChild(graphics);
    }, [width, height]);

    return (
      <Container
        interactive
        key={index}
        value={index}
        cursor='pointer'
        ref={graphicRef}
        onpointerup={handleSelectCard}
        onpointerover={isMobile() ? () => {} : handlePointerOver}
        onpointerleave={isMobile() ? () => {} : handlePointerLeave}
        name='jackPotSceneItemGraphicsContainer'
      />
    );
  }
);

export default JackPotSceneItemGraphics;
